// extracted by mini-css-extract-plugin
export default {"root":"DraggableItem_root__Ry3Y3"};